@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<kb-tab-group>
  @for (item of attributes.items; track item) {
    <kb-tab-panel
      [headingLevel]="item.attributes.heading === 'H2' ? 2 : item.attributes.heading === 'H3' ? 3 : 'none'"
    >
      <kb-panel-header><span [appEditorId]="item.editorIds?.title" [appTrackClick]="'Tab:' + item.attributes['title']">{{item.attributes['title']}}</span></kb-panel-header>
      <kb-panel-content>
        <div [appEditorId]="item.editorId" kb-layout="grid">
          @for (section of item.attributes.sections; track section) {
            @if (isCopyTextSection(section)) {
              <app-copy-text [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds"></app-copy-text>
            }
            @if (isMediumSection(section)) {
              <app-medium [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds"></app-medium>
            }
            @if (isDownloadList(section)) {
              <app-download-list [attributes]="section.attributes" [appEditorId]="section.editorId" [editorIds]="section.editorIds"></app-download-list>
            }
          }
        </div>
      </kb-panel-content>
    </kb-tab-panel>
  }
</kb-tab-group>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
